// extracted by mini-css-extract-plugin
export var checkbox = "_a1-0";
export var circle = "_a1-3";
export var horizontalContainer = "_a1-7";
export var sm = "_a1-5";
export var switch0 = "_a1-2";
export var switchDisabled = "_a1-8";
export var switchEnabled = "_a1-1";
export var textSwitchContainer = "_a1-9";
export var textSwitchOption = "_a1-a";
export var textSwitchOptionSelected = "_a1-b";
export var verticalContainer = "_a1-6";
export var xs = "_a1-4";